export const SESSION_EXPIRED_MESSAGE = 'Your session expired, or this page is out of date. Refresh the page, then save again. Sign in again if the problem continues.';
export const DEFAULT_SAVE_ERROR = 'Something went wrong while saving. Please try again.';
export const MAX_SERVER_MESSAGE = 300;

function capped(message) {
  return String(message).slice(0, MAX_SERVER_MESSAGE);
}

// Devise uses 401 when the session is no longer valid. Rails middleware uses
// a status/error envelope for an expired CSRF token. Controller validation
// errors use a field map and remain ordinary save errors.
export function parseSaveErrorBody(body, responseStatus) {
  if (responseStatus === 401) {
    return { message: SESSION_EXPIRED_MESSAGE, sessionExpired: true };
  }

  if (body && !Array.isArray(body) && typeof body === 'object' &&
      typeof body.status === 'number' && typeof body.error === 'string') {
    if (responseStatus === 422 && body.status === 422) {
      return { message: SESSION_EXPIRED_MESSAGE, sessionExpired: true };
    }
    return { message: DEFAULT_SAVE_ERROR, sessionExpired: false };
  }

  if (body && !Array.isArray(body) && typeof body === 'object') {
    const messages = Object.entries(body).map(([field, values]) => {
      const text = Array.isArray(values) ? values.join(', ') : String(values);
      return field === 'base' ? text : `${field} ${text}`;
    });
    if (messages.length) {
      return { message: capped(messages.join('. ')), sessionExpired: false };
    }
  }

  return { message: DEFAULT_SAVE_ERROR, sessionExpired: false };
}
